<template>
  <div>
    <TopBarBackText title="B2B Solution" />
    <section class="b2b-solution-container">
      <nuxt-img
        src="/img/b2b/b2b-solution-banner.webp"
        class="banner-img"
        alt="b2b-solution-banner"
      />
      <div class="banner-description">
        <span class="banner-icon">▶▶▶</span>
        <span class="banner-title">간편하게 문의하고<br />빠르게 상담 받아보세요</span>
        <span class="banner-icon">▶▶▶</span>
      </div>
      <div class="b2b-solution-content">
        <div class="content-tab scm">
          <p>SCM</p>
        </div>
        <div class="content-img">
          <nuxt-img
            src="/img/b2b/b2b-scm.png"
            alt="b2b-scm"
            class="content-b2b-img scm-img"
          />
        </div>
        <div class="content-description center-position scm-content-description">
          <p>· 업체를 위한 B2B 전용 시스템을 무료로 제공해요.</p>
          <p>· 간단하고 직관적으로 사용성이 높아요.</p>
        </div>
      </div>
      <div class="b2b-solution-content">
        <div class="content-tab api">
          <p>API</p>
        </div>
        <div class="content-img">
          <nuxt-img
            src="/img/b2b/b2b-api.png"
            alt="b2b-api"
            class="content-b2b-img api-img"
          />
        </div>
        <div class="content-description">
          <p>· 자체 브랜딩 된 상품을 운영할 수 있어요.</p>
          <p>· 유심사가 서비스하는 기능을 고객에게 동일하게 제공해요.</p>
          <p>· 다른 서비스와도 연계가 가능해 확장성이 좋아요.</p>
        </div>
      </div>
      <div class="b2b-solution-content">
        <div class="content-tab affiliate">
          <p>수익 쉐어</p>
        </div>
        <div class="content-img">
          <nuxt-img
            src="/img/b2b/b2b-profit-share.png"
            alt="b2b-affiliate"
            class="content-b2b-img affiliate-img"
          />
        </div>
        <div class="content-description center-position">
          <p>· 가장 간단하게 시작할 수 있어요.</p>
          <p>· 별도 리소스가 발생하지 않아요.</p>
          <p>· 배송 및 고객 서비스는 유심사가 모두 할게요.</p>
        </div>
      </div>
      <div class="b2b-solution-question">
        <p class="question-title">자주하는 질문</p>
        <div
          v-for="(item, index) in questionList"
          :key="index"
          class="question-content"
        >
          <p class="question">Q. {{ item.question }}</p>
          <p class="answer">A. {{ item.answer }}</p>
        </div>
        <button
          id="gtm_b2b_solution_contact_btn"
          class="inquiry-btn"
          @click="handleClick"
        >
          문의하기
        </button>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'center'
})

const { ogUrl, ogTitle } = useSeo()

useSeoMeta({
  title: 'B2B Solution - SCM·API·수익쉐어',
  description:
    'eSIM·USIM 구매 및 판매를 위한 B2B 전용 솔루션 제공. SCM 제공, API 연동, 수익쉐어로 비즈니스 성장을 지원합니다.',
  ogType: 'website',
  ogUrl: () => ogUrl('b2b/solution'),
  ogTitle: () => ogTitle('B2B Solution - SCM, API, 수익쉐어 연동 서비스 '),
  ogDescription:
    'eSIM·USIM 구매 및 판매를 위한 SCM, API, 수익쉐어(어필리에이트) 연동 솔루션으로 비즈니스 파트너십을 강화하세요.',
  twitterCard: 'summary',
  twitterTitle: () => ogTitle('B2B Solution - SCM, API, 수익쉐어 연동 서비스 '),
  twitterDescription:
    'eSIM·USIM 구매 및 판매를 위한 SCM, API, 수익쉐어(어필리에이트) 연동 솔루션으로 비즈니스 파트너십을 강화하세요.',
  keywords:
    'eSIM B2B 솔루션, eSIM API, eSIM SCM, 수익쉐어, 어필리에이트, 데이터로밍, 글로벌 eSIM, 글로벌 유심, 이심, 유심, 유심사, 해외사업자',
  ogSiteName: '유심사 B2B Solution'
})

const questionList = [
  {
    question: '솔루션 컨설팅 비용이 있나요?',
    answer: '아니요. 단순 문의부터 솔루션 이용까지 모두 무료 입니다.'
  },
  {
    question: 'SIM공급가를 알고 싶은데 어떻게 하나요?',
    answer: '아래 문의하기 버튼을 통해 문의 주시면 상세히 안내 도와드리겠습니다.'
  },
  {
    question: '모든 솔루션을 도입하고 싶은데 가능한가요?',
    answer: '네. 물론 가능하며 일부만 도입하는 것도 가능합니다.'
  },
  {
    question: '해외 사업자인데 솔루션 도입 가능한가요?',
    answer: '네. 해외 사업자도 가능 합니다.'
  },
  {
    question: '저는 조금 애매해서 상담이 따로 필요한데 문의해도 되나요?',
    answer: '네. 물론입니다. 편하게 문의 주세요!'
  },
  {
    question: '문의하면 언제 연락이 오나요?',
    answer: '영업일 기준 최소 1시간 ~ 최대 2일 이내 연락드립니다.'
  }
]

const handleClick = () => {
  window.open('https://walla.my/usimsa-b2b-solution', '_blank')
}
</script>

<style lang="scss" scoped>
.b2b-solution-container {
  padding-top: 56px;
  .banner-img {
    width: 100%;
  }
  .banner-description {
    height: 100px;
    width: 100%;
    background: $brand-point;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    margin-top: -4px;
    margin-bottom: 70px;
    .banner-title {
      color: $base-white;
      text-align: center;
      font-size: 18px;
      font-weight: 700;
    }
    .banner-icon {
      color: #ffffff4d;
      font-family: 'Gmarket Sans TTF';
      font-size: 10px;
      font-weight: 500;
    }
  }
  .b2b-solution-content {
    padding: 0 30px 70px;
    .content-tab {
      border-radius: 10px;
      display: flex;
      justify-content: center;
      padding: 17px 80px;
      &.scm {
        border: 1px solid #cee1ef;
        background: #e7f5ff;
        p {
          color: $brand-point;
        }
      }
      &.api {
        border: 2px solid #f0d7da;
        background: #ffe7ea;
        p {
          color: #fb5c6f;
        }
      }
      &.affiliate {
        border: 2px solid #ece0ca;
        background: #fff5e2;
        p {
          color: #f6b33d;
        }
      }
      p {
        font-size: 24px;
        font-weight: 700;
      }
    }
    .content-img {
      margin-top: 13px;
      border-radius: 10px;
      border: 1px solid #d9d9d9;
      background: #f3f3f3;
      padding: 29px 0 34px;
      display: flex;
      justify-content: center;
      align-items: center;
      .content-b2b-img {
        &.scm-img {
          width: 95%;
        }
        &.api-img {
          width: 70%;
        }
        &.affiliate-img {
          width: 70%;
          max-width: 600px;
        }
      }
    }
    .content-description {
      margin-top: 32px;
      &.center-position {
        text-align: center;
        &.scm-content-description {
          p {
            max-width: 350px;
          }
        }
        p {
          display: inline-block;
          text-align: left;
          width: 100%;
          max-width: 300px;
        }
      }
      p {
        font-size: 17px;
        font-weight: 500;
        line-height: 32px;
        letter-spacing: -0.8px;
        word-break: keep-all;
      }
    }
  }
  .b2b-solution-question {
    padding: 60px 30px 0;
    background: #e9e9e9;
    .question-title {
      font-size: 27px;
      font-weight: 800;
    }
    .question-content {
      margin-top: 20px;
      .question {
        color: #525252;
        font-size: 17px;
        font-weight: 700;
      }
      .answer {
        color: #666;
        font-size: 18px;
        font-weight: 400;
        margin-top: 8px;
        word-break: keep-all;
      }
    }
    .inquiry-btn {
      margin: 70px 0 80px;
      width: 100%;
      height: 72px;
      border-radius: 12px;
      background-color: $base-black;
      color: $base-white;
      font-size: 22px;
      font-weight: 600;
      cursor: pointer;
    }
  }
}
</style>
